module.exports = __webpack_public_path__ + "img/scene1.6d54f2a5.gif";